import React from 'react';
import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';

import Text from '../basic/Text';
import { Grid, Cell } from '../basic/layouts/Grid';
import { Overline } from '../basic/layouts/Section';

import theme from '../../styles/theme';

const QuoteGrid = styled(Grid)`
	align-items: center;

	.quote__body {
		margin: 16px 0;
		font-style: italic;
		letter-spacing: 0.2px;
		padding-right: 10px;
	}

	.quote__name-title {
		font-size: 14px;
		span {
			text-transform: uppercase;
			font-family ${theme.font.semiBold};
			margin-right: 10px;
		}
	}
`;

const LogoPhotoCell = styled(Cell)`
	position: relative; /* Ensures positioning context for the logo */

	.quote__source-photo {
		img {
			width: calc(100% - 44px);
		}
	}

	.quote__source-logo {
		position: absolute;
		bottom: 0;
		right: 44px;
		width: 88px; /* Size of the logo box */
		height: 88px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #789ee8; /* Optional, for contrast */
		border-radius: 12px;
		overflow: hidden; /* Ensures logo doesn't overflow */
		transform: translate(44px, 44px); /* Moves logo 44px outside the image */
		z-index: 1;
		box-shadow: 0px 0px 24px rgba(28, 39, 62, 0.25);

		img {
			width: 100%;
			padding: 10px;
			filter: brightness(0) invert(1);
		}
	}
`;

const TwoColumnLogoQuote = ({
	bioPhoto,
	bioName,
	bioTitle,
	overline,
	quote,
	bioLogo,
}) => {
	return (
		<QuoteGrid gridGap="32px">
			{bioPhoto && (
				<LogoPhotoCell span={4}>
					<div className="quote__source-photo">
						{bioPhoto.gatsbyImageData ? (
							<GatsbyImage
								image={bioPhoto.gatsbyImageData}
								alt={`Photo of ${bioName}`}
							/>
						) : (
							<img src={bioPhoto} alt={`Photo of ${bioName}`} />
						)}
					</div>
					<div className="quote__source-logo">
						{bioLogo && bioLogo.gatsbyImageData ? (
							<GatsbyImage
								image={bioLogo.gatsbyImageData}
								alt={`Photo of ${bioName}`}
							/>
						) : (
							<img src={bioLogo} alt={`Photo of ${bioName}`} />
						)}
					</div>
				</LogoPhotoCell>
			)}
			<Cell
				span={8}
				start={!bioPhoto && 3}
				style={!bioPhoto ? { textAlign: 'center' } : null}
				className="quote__text"
			>
				<Overline>{overline}</Overline>
				<Text component="b2" className="quote__body">
					"{quote}"
				</Text>
				<Text component="b6" className="quote__name-title">
					<span>{bioName}</span> {bioTitle}
				</Text>
			</Cell>
		</QuoteGrid>
	);
};

export default TwoColumnLogoQuote;
